export type ActivityStatus =
  | "ON_REGISTRATION"
  | "CLOSED_REGISTRATION"
  | "ON_PROGRESS"
  | "FINISHED"
  | "CANCELLED";

export const ACTIVITY_STATUS_LABEL: Record<ActivityStatus, string> = {
  ON_REGISTRATION: "Pendaftaran dibuka",
  CLOSED_REGISTRATION: "Pendaftaran ditutup",
  ON_PROGRESS: "Sedang berjalan",
  FINISHED: "Selesai",
  CANCELLED: "Dibatalkan",
};

/**
 * The single definition of "finished" (spec.md 5.1): stored status `FINISHED`,
 * or status other than `CANCELLED` whose endDate has already elapsed. Mirrors
 * the API's `status: Not(Status.CANCELED)` + `endDate: LessThan(now)`, so the
 * strict `<` comparison is deliberate. A stored `CANCELLED` stays cancelled
 * however long ago it ended. `status` is widened to `string` because the wire
 * value is unvalidated; anything unrecognised falls through to the date rule,
 * matching the API's `Not(...)` semantics.
 */
export const isActivityFinished = (
  status: string | undefined,
  endDate: string | Date | null | undefined,
  now: Date = new Date(),
): boolean => {
  if (status === "FINISHED") return true;
  if (status === "CANCELLED") return false;
  if (!endDate) return false;
  const end = new Date(endDate).getTime();
  return Number.isFinite(end) && end < now.getTime();
};
